const appendMembersSection = () => {
    const $membersSection = $('[data-component="members-section"]');

    if(breakpoint === 'xs' || breakpoint === 'sm') {
        $membersSection.insertAfter('[data-content="video-description-second"]').css('display', 'block');
    }
};

const movePlaceholder3 = () => {
    const $ph3 = $('[data-placeholder="ph3"]');

    if(breakpoint === 'xs' || breakpoint === 'sm') {
        $ph3.appendTo('[data-composant="resource-details_zone2"]').css('display', 'block');
    }else{
        $ph3.css('display', 'block');
    }

    $(window).on('resize', function() {
        setTimeout(() => {
            if(breakpoint !== 'xs' || breakpoint !== 'sm') {
                $ph3.appendTo('[data-composant="resource-document-access"]');
            }

            if(breakpoint === 'xs' || breakpoint === 'sm') {
                $ph3.appendTo('[data-composant="resource-details_zone2"]');
            }
        }, 500);
    });
};

const initResourcesDetails = () => {
    if($('[resource-details-layout="resource-video"]').length) {
        appendMembersSection();
    }

    if($('[resource-details-layout="resource-document-deprecated"]').length) {
        movePlaceholder3();
    }
};

export default initResourcesDetails;